import gql from "graphql-tag.macro";

const queryLoadProjects = gql`
{
    projects {
        edges {
            node {
                _id
                name
            }
        }
    }
}
`;

export const loadProjects = async ({ client }) => {
    const {
        data: {
            projects: { edges: results },
        },
    } = await client.query({
        query: queryLoadProjects,
    });

    return results?.map(({ node }) => ({ id: node._id, name: node.name }));
};
